import { DownOutlined } from '@ant-design/icons';
import { Collapse, theme } from 'antd';
import { useWatch } from 'react-hook-form';
import { CreateTicketFormValues } from '../../../../../../../types/form';
import CommentInput from '../../../../../../components/TicketPage/CommentInput';
import CommentTypeSelect from '../../../../../../components/TicketPage/CommentTypeSelect';
import { SetStateType, ticketInteractionViewViewType } from '../../../../../../model/types';
import DistributionListSection from './DistributionListSection';

const { Panel } = Collapse;

interface Props {
    commentCollapseActiveKey: string[];

    toggleComment: SetStateType<string | string[]>;
    setCommentsViewType?: SetStateType<ticketInteractionViewViewType>;
}

export default function CommentContainer({ commentCollapseActiveKey, toggleComment, setCommentsViewType }: Props) {
    const {
        token: { margin }
    } = theme.useToken();

    const watchedCommentType = useWatch<CreateTicketFormValues, 'comment.publicVisible'>({
        name: 'comment.publicVisible'
    });

    const watchedCommentChannelType = useWatch<CreateTicketFormValues, 'comment.channel'>({
        name: 'comment.channel'
    });

    return (
        <Collapse
            activeKey={commentCollapseActiveKey}
            // ghost
            onChange={toggleComment}
            size="small"
            expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? -90 : 0} style={{ marginTop: margin / 2 }} />
            )}
        >
            <Panel header={<CommentTypeSelect setCommentsViewType={setCommentsViewType} />} key="1">
                {watchedCommentChannelType === 'WEB' && watchedCommentType && <DistributionListSection />}
                <CommentInput commentChannel={watchedCommentChannelType} publicVisible={watchedCommentType} />
            </Panel>
        </Collapse>
    );
}
